import React, { useContext, useMemo, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import TableComponent from "../widgets/Table/TableComponent";
// import { logsData } from "../../data/LogsData";
import { ILogsModel } from "../../models/LogsModel";
import { createColumnHelper } from "@tanstack/react-table";
import { text_convert_lower } from "../../helpers/GenericHelpers";
import ToolTip from "../../commonfields/ToolTip";
import { faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { v4 as uuid } from "uuid";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Avatar from "react-avatar";
import moment from "moment";
import { getAllLogs } from "../../helpers/LogHelpers";
import { ThemeContext } from "../../models/ThemeContext";
import { ThemeTypes } from "../../models/SharedModel";

interface ILogsModalProps {
  logsModal: boolean;
  toggleLogsModal: () => void;
}

const filterValues = [
  {
    filterId: uuid(),
    label: "Role Restriction",
    value: false,
    checkValue: (value: ILogsModel) =>
      value?.violations?.filter(
        (each) =>
          each?.toLocaleLowerCase()?.includes("role") &&
          each?.toLocaleLowerCase()?.includes("restriction")
      )?.length > 0,
  },
  {
    filterId: uuid(),
    label: "GDPR",
    value: false,
    checkValue: (value: ILogsModel) => value?.tags?.includes("GDPR"),
  },
  {
    filterId: uuid(),
    label: "PHI",
    value: false,
    checkValue: (value: ILogsModel) => value?.tags?.includes("PHI"),
  },
  {
    filterId: uuid(),
    label: "PII",
    value: false,
    checkValue: (value: ILogsModel) => value?.tags?.includes("PII"),
  },
];

const LogsModal = (props: ILogsModalProps) => {
  const { logsModal, toggleLogsModal } = props;
  const logsData: ILogsModel[] = getAllLogs()

  // states
  const [filters, setFilters] = useState(filterValues);
  const [optionsDropdown, setOptionsDropdown] = useState("");

  // helpers
  const toggleOptionsDropdown = (value: string) =>
    setOptionsDropdown((prev) => (prev === value ? "" : value));

  const fetchData = (start: number, size: number, tableData: any) => {
    return {
      data: tableData.slice(start, start + size),
      meta: {
        totalRowCount: tableData.length,
      },
    };
  };

  // const columns = useMemo<any>(
  //   () => [
  //     {
  //       accessorKey: "id",
  //     },
  //     {
  //       accessorKey: "username",
  //     },
  //     {
  //       accessorKey: "solution",
  //     },
  //     {
  //       accessorKey: "solution_type",
  //     },
  //     {
  //       accessorKey: "api",
  //     },
  //     {
  //       accessorKey: "prompt",
  //     },
  //     {
  //       accessorKey: "result",
  //     },
  //     {
  //       accessorKey: "tags",
  //     },
  //     {
  //       accessorKey: "violations",
  //     },
  //     {
  //       accessorKey: "role",
  //     }
  //   ],
  //   []
  // );

  const columnHelper = createColumnHelper<ILogsModel>();

  const columns = [
    columnHelper.accessor("time", {
      header: () => <span className="header">Timestamp</span>,
      cell: (info) => moment(info.getValue())?.format("MM/DD/YY hh:mm A"),
    }),
    columnHelper.accessor("solution_type", {
      header: () => <span className="header">Type</span>,
      cell: (info) => (
        <div className={`proj-type ${info.getValue()?.toLocaleLowerCase()}`}>
          {text_convert_lower(info.getValue())}
        </div>
      ),
    }),
    columnHelper.accessor("solution", {
      header: () => <span className="header">Solution</span>,
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor("username", {
      header: () => <span className="header">User Name</span>,
      cell: (info) => <><Avatar 
      round
      size="16px"
      textSizeRatio={1.75}
      textMarginRatio={0.3}
      name={info.getValue()}
      maxInitials={2} 
    /> {info.getValue()}</>,
    }),
    columnHelper.accessor("api", {
      header: () => <span className="header">API</span>,
      cell: (info) => <ToolTip value={info?.getValue()} count={15} />,
    }),
    columnHelper.accessor("prompt", {
      header: () => <span className="header">Prompt</span>,
      cell: (info) => <ToolTip value={JSON.stringify(info?.getValue())} count={15} />,
    }),
    columnHelper.accessor("result", {
      header: () => <span className="header">Result</span>,
      cell: (info) => <ToolTip value={typeof info?.getValue() === 'string'  ? info?.getValue() : JSON.stringify(info?.getValue())} count={15} />,
    }),
    columnHelper.accessor("tags", {
      header: () => <span className="header">Tags</span>,
      cell: (info) => (
        <div className="tags-list">
          {info?.row?.original?.tags?.map((each) => (
            <div className={`tag ${each?.toLocaleLowerCase()}`}>{each}</div>
          ))}
        </div>
      ),
    }),
    columnHelper.accessor("violations", {
      header: () => <span className="header">Violations</span>,
      cell: (info) => (
        <ToolTip value={info?.getValue()?.join(" ")} count={15} />
      ),
    }),
    columnHelper.accessor("role", {
      header: () => <span className="header">Role</span>,
      cell: (info) => <div className="role">{info.getValue()}</div>,
    }),
    // columnHelper.display({
    //   id: 'actions',
    //   cell: info => <>
    //     <Dropdown
    //     // Todo: change its project id
    //       isOpen={optionsDropdown === info?.row?.original?.log_id}
    //       toggle={(e: any) => toggleOptionsDropdown(info?.row?.original?.log_id)}
    //     >
    //       <DropdownToggle>
    //         <FontAwesomeIcon icon={faEllipsisVertical} />
    //       </DropdownToggle>
    //       <DropdownMenu>
    //         <DropdownItem>Alerts</DropdownItem>
    //         <DropdownItem>Cases</DropdownItem>
    //       </DropdownMenu>
    //     </Dropdown>
    //   </>,
    // }),
  ];

  const getRowClassName = (row: any) => {
    let className = "default";
    if (row?.original?.tags?.length) className += " has-tags";
    if (row?.original?.violations?.length) className += " has-violations";
    return className;
  };

  const changeFilters = (filter: any) => {
    setFilters((prev) =>
      prev?.map((each) =>
        each?.filterId === filter?.filterId
          ? { ...each, value: !each?.value }
          : each
      )
    );
  };

  const getFilteredValues = (project: ILogsModel) => {
    const activeFilters = filters?.filter((each) => each?.value);
    if (activeFilters?.length > 0) {
      return activeFilters?.every((fill) => fill?.checkValue(project));
    } else return true;
  };

  const data = useMemo(
    () => logsData?.filter((each) => getFilteredValues(each)),
    [logsData, filters]
  );

  const { themeName } = useContext(ThemeContext);
  return (
    <Modal
      className={`project-modal logs-modal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
      isOpen={logsModal}
      toggle={toggleLogsModal}
    >
      <ModalHeader toggle={toggleLogsModal}>Solution Logs</ModalHeader>
      <ModalBody>
        <div className="logs-table">
          <div className="filters">
            <div className="filter-text">Filters</div>
            <div className="filter-list">
              {filters?.map((each) => (
                <div
                  key={each?.filterId}
                  className={`filter-item ${each?.value ? "active" : ""}`}
                  onClick={() => !each?.value && changeFilters(each)}
                >
                  {each?.label}
                  {each?.value ? (
                    <span
                      className="filter-close"
                      onClick={() => changeFilters(each)}
                    >
                      <FontAwesomeIcon icon={faXmark} />
                    </span>
                  ) : (
                    <></>
                  )}
                </div>
              ))}
            </div>
          </div>
          <TableComponent
            columns={columns}
            tableData={data}
            enableSort={true}
            enableFilter={true}
            enableGlobalFilter={false}
            getRowClassName={getRowClassName}
            infiniteScroll={{
              display: true,
              fetchSize: 25,
              handlefetch: fetchData,
            }}
          />
        </div>
      </ModalBody>
    </Modal>
  );
};

export default LogsModal;
